import { InvestmentPackageManager } from '../InvestmentPackageManager';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class InvestmentPackageManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/investment-package`, headers);
  }

  createInvestmentPackageManager(token: string): InvestmentPackageManager {
    return new InvestmentPackageManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
